import BaseFormModal from "@affine/core/desktop/pages/workspace/task-page/components/BaseFormModal";
import { useState, useRef, useEffect } from 'react'
import { notify } from "@affine/component";
import { Form } from 'antd'
import { FAntdInput } from 'izid'
import { easyNotNull } from "@affine/core/desktop/pages/workspace/task-page/utils/antd-validator";
import { GlobalDialogService } from "@affine/core/modules/dialogs";
import { useService } from '@toeverything/infra';
import { AuthService, FetchService } from "@affine/core/modules/cloud";
import * as style from "@affine/core/components/sign-in/style.css";

export const AntdChangePwd  = () => {
  const authService = useService(AuthService);
  const fetchService = useService(FetchService);

  // 重置密码
  const [resetPwdStep, setResetPwdStep] = useState<number>(0)
  const resetPwdFormRef = useRef()
  const [resetPwdFormData, setResetPwdFormData] = useState({})
  const isSubmit = useRef(false)
  const resetPwdFormSubmit = data => {
    if (resetPwdStep === 0) {
      // 校验密码
      return fetchService.fetch('/api/avatars/verify-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          currentPassword: data.userPassword
        })
      }).then(res => res.json()).then(res => {
        console.log('用户密码校验', res)
        if (res.code !== 200) {
          notify.warning({
            title: res.message
          })
        } else {
          notify.success({
            title: res.message
          })
          setResetPwdStep(1)
        }
      })
    } else {
      return fetchService.fetch('/api/avatars/change-password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          newPassword: data.password
        })
      }).then(res => res.json()).then(res => {
        if (res.code === 200) {
          isSubmit.current = true
          notify.success({
            title: '密码修改成功，请重新登录'
          })
          resetPwdFormRef.current?.close()
          authService.signOut()
        } else {
          notify.error({
            title: res.message
          })
        }
      })
    }
  }

  useEffect(() => {
    resetPwdFormRef.current?.open({})
  }, [resetPwdFormRef])


  const globalDialogService = useService(GlobalDialogService);

  return <BaseFormModal
    data={ resetPwdFormData }
    setData={ setResetPwdFormData }
    ref={ resetPwdFormRef }
    onSubmit={ resetPwdFormSubmit }
    addTitle={ resetPwdStep === 0 ? '校验密码' : '修改密码' }
    okText={ resetPwdStep === 0 ? '下一步' : '提交' }
    onReset={() => {
      if (isSubmit.current) return
      globalDialogService.open('setting', {
        activeTab: 'account',
      })
    }}
  >
     {
       resetPwdStep === 0 &&
       <Form.Item
         label={'旧密码'}
         name={'userPassword'}
         rules={easyNotNull('旧密码')}
       >
         <FAntdInput.Password />
       </Form.Item>
     }
     {
       resetPwdStep === 1 &&
       <>
         <Form.Item
           name={ 'password' }
           label={ <label className={ style.inputLabel }>密码</label> }
           validateTrigger="onBlur"
           rules={ [
             {
               required: true,
               message: '密码不能为空'
             },
             {
               validator: (_, value) => {
                 if (!value) return Promise.resolve();
                 const regex = /^[a-zA-Z0-9_]{8,16}$/;
                 if (!regex.test(value)) return Promise.reject('密码由8-16位数字字母下划线组成');
                 return Promise.resolve();
               }
             }
           ] }
         >
           <FAntdInput.Password onBlur={ () => {
             const againPassword = resetPwdFormRef.current?.form.getFieldValue('againPassword')
             if (againPassword) resetPwdFormRef.current?.form.validateFields([ 'againPassword' ])
           } } placeholder={ '请输入密码' } />
         </Form.Item>
         {resetPwdFormData.password &&
         <Form.Item
           name={ 'againPassword' }
           validateTrigger="onBlur"
           label={ <label className={ style.inputLabel }>确认密码</label> }
           rules={ [
             {
               required: true,
               message: '请再次输入密码'
             },
             ({ getFieldValue }) => ({
               validator: (_, value) => {
                 if (!value) return Promise.resolve();
                 const password = getFieldValue('password')
                 if (password !== value) return Promise.reject('两次输入的密码不一致');
                 return Promise.resolve();
               }
             })
           ] }
         >
           <FAntdInput.Password placeholder={ '请再次输入密码' } />
         </Form.Item>
         }
       </>
     }
  </BaseFormModal>
}
